<template>
    <router-link
            v-if="title"
            :to="url ? url : '#'"
            class="theme-btn uppercase h-12 font-medium py-spc1 px-spc2 text-white text-base inline-block leading-spc1"
            :class="className">
        {{title}}
    </router-link>
</template>

<script>
    export default {
        name: "ThemeButton",
        props: ['title', 'url', 'className']
    }
</script>

<style scoped>

</style>